import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles.module.scss';
import { Image, Row, Col} from 'react-bootstrap';
import _ from "lodash";
import DOMPurify from 'dompurify';
import NetsuiteIcon from 'src/legacy/images/netsuite.png';
import NetsuiteConfigurationPage from './NetsuiteConfigurationPage';
import DeactivateIntegrationContainer from 'src/legacy/components/DeactivateIntegration/index';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import InputField from 'src/legacy/components/InputField';
import BackButton from 'src/legacy/components/BackButton';
import { localizedStrings } from 'src/localization/index.jsx';

class NetsuiteView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      deleteConfirmation: false,
      instanceUrl: "",
      errors: {},
      client_id: null,
      client_secret: null,
      account_id: null,
    };

    this.handleAuthenticate = this.handleAuthenticate.bind(this);
    this.handleAuthenticateEvent = this.handleAuthenticateEvent.bind(this);
    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);
    this.handleValidate = this.handleValidate.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedNetsuite = localizedStrings.components.integrations.netsuite;
  }

  componentDidMount() {
    this.props.fetchNetsuiteIntegration();
  }

  _handleDeactivateClicked() {
    this.setState({
      deleteConfirmation: true,
    });
  }

  handleOverrideAuthenticate() {
    if(!this.props.integration) {
      return;
    }

    this.props.authorizeAccountByIntegration(this.props.integration.id)
    .then(() => {
      //Calculate Position
      var dualScreenLeft =
        window.screenLeft != undefined ? window.screenLeft : window.screen.left;
      var dualScreenTop =
        window.screenTop != undefined ? window.screenTop : window.screen.top;

      var width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : window.screen.width;
      var height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : window.screen.height;

      var w = 0.8 * width;
      var h = 0.8 * height;

      var left = width / 2 - w / 2 + dualScreenLeft;
      var top = height / 2 - h / 2 + dualScreenTop;

      var newWindow = window.open(
        this.props.url,
        `Authorize Netsuite Account`,
        "scrollbars=yes, width=" +
          w +
          ", height=" +
          h +
          ", top=" +
          top +
          ", left=" +
          left
      );

      // Puts focus on the newWindow
      if (newWindow.focus) {
        newWindow.focus();
      }

      //Attaching message event listner
      var eventMethod = window.addEventListener
        ? "addEventListener"
        : "attachEvent";
      var eventer = window[eventMethod];
      var messageEvent =
        eventMethod == "attachEvent" ? "onmessage" : "message";

      // Listen to message from child window
      eventer(messageEvent, this.handleAuthenticateEvent, false);
    });

  return false;
  }

  validateAuthError() {
    let integration = this.props.integration;
    if (
      integration.primaryIntegration &&
      integration.primaryIntegration.state && integration.primaryIntegration.state.code === "ok"
    ) {
      return true;
    } else if (
      integration &&
      !integration.primaryIntegration &&
      integration.state.code === "ok"
    ) {
      return true;
    }
    return false;
  }

  _handleFieldChange(field, e) {
    let value = e.target.value;
    this.setState({
      [field]: value,
    });
  }

  render() {
    if (this.props.loading) {
      return this._renderLoadingMessage();
    }

    var isAuthenticated = false;

    if (
      this.props.integration &&
      this.validateAuthError() &&
      !this.props.error
    ) {
      isAuthenticated = true;
    }

    return (
      <div className={styles.content}>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>
            <BackButton
              className={styles.back}
              title={this.localizedCommons.actions.back}
              onClick={() => {
                this.props.navigate("/settings/integrations");
              }}
            />

            <div className={styles.heading}>
              <Image src={NetsuiteIcon} />
              <h2 className={styles.name}>{ this.localizedNetsuite.title }</h2>
              <p className={styles.description}>
                { this.localizedNetsuite.sub_text }
              </p>
              {this.props.integration &&
                this.validateAuthError() &&
                this.props.user.admin && (
                  <button
                    className={styles.button}
                    disabled={this.props.deactivating}
                    onClick={this._handleDeactivateClicked}
                  >
                    {this.props.deactivating && `${this.localizedIntegrations.actions.deactivating}...`}
                    {!this.props.deactivating && this.localizedIntegrations.actions.deactivate }
                  </button>
                )}
            </div>
          </Col>
          <Col md={9} className={styles.right}>
            {!isAuthenticated && (
              <div className={styles.authorize}>
                <h3>{ this.localizedNetsuite.activate.title }</h3>
                <p dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.localizedNetsuite.activate.sub_text)}} />


                <div className={styles.form}>
                  <InputField
                    className={styles.field}
                    title={this.localizedNetsuite.client_id}
                    type="password"
                    onChange={this._handleFieldChange.bind(this, "client_id")}
                    errorMessage={this.state.errors["client_id"]}
                  />
                  <InputField
                    className={styles.field}
                    type="password"
                    title={this.localizedNetsuite.client_secret}
                    onChange={this._handleFieldChange.bind(
                      this,
                      "client_secret"
                    )}
                    errorMessage={this.state.errors["client_secret"]}
                  />
                </div>

                <button
                  className={styles.authButton}
                  onClick={this.handleAuthenticate}
                  disabled={this.props.authenticating}
                >
                  {this.props.authenticating && `${this.localizedIntegrations.actions.authenticating}...` }

                  {!this.props.authenticating &&  this.localizedIntegrations.actions.authenticate }
                </button>
              </div>
            )}
            {isAuthenticated && (
              <NetsuiteConfigurationPage
                store={this.context.store}
                integration={this.props.integration}
                OverrideConfig={this.handleOverrideAuthenticate.bind(this)}
              />
            )}
          </Col>
        </Row>
        <DeactivateIntegrationContainer
          name={this.localizedNetsuite.deactivate_slider.title}
          type="netsuite"
          message={this.localizedNetsuite.deactivate_slider.sub_text}
          show={this.state.deleteConfirmation}
          onCancel={() => {
            this.setState({
              deleteConfirmation: false,
            });
          }}
        />
      </div>
    );
  }

  canEdit() {
    if (this.props.user.admin) {
      return true;
    } else if (this.props.integration.createdBy) {
      return this.props.integration.createdBy.id === this.props.user.id;
    }
    return false;
  }


  handleValidate() {
    this.handleAuthenticate();
  }

  _renderLoadingMessage() {
    return (
      <LoadingMessage
        className={styles.loadingMessage}
        message={`${this.localizedNetsuite.loading.config}...`}
        visible={this.props.loading}
      />
    );
  }

  _validateForm(){
    var errors = {};
    console.log(this.state)
    if(!this.state.client_id){
      errors['client_id'] = this.localizedNetsuite.error_messages.client_id;
    }

    if(!this.state.client_secret){
      errors['client_secret'] = this.localizedNetsuite.error_messages.client_secret;
    }

    return errors;
  }


  handleAuthenticate() {

    let errors = this._validateForm();

    this.setState({
      errors: errors
    });

    if(Object.keys(errors).length > 0){      
      return;
    }

    this.props
      .authorizeAccount(this.state.client_id, this.state.client_secret)
      .then(() => {
        //Calculate Position
        var dualScreenLeft =
          window.screenLeft != undefined ? window.screenLeft : window.screen.left;
        var dualScreenTop =
          window.screenTop != undefined ? window.screenTop : window.screen.top;

        var width = window.innerWidth
          ? window.innerWidth
          : document.documentElement.clientWidth
          ? document.documentElement.clientWidth
          : window.screen.width;
        var height = window.innerHeight
          ? window.innerHeight
          : document.documentElement.clientHeight
          ? document.documentElement.clientHeight
          : window.screen.height;

        var w = 0.8 * width;
        var h = 0.8 * height;

        var left = width / 2 - w / 2 + dualScreenLeft;
        var top = height / 2 - h / 2 + dualScreenTop;

        var newWindow = window.open(
          this.props.url,
          `Authorize Netsuite Account`,
          "scrollbars=yes, width=" +
            w +
            ", height=" +
            h +
            ", top=" +
            top +
            ", left=" +
            left
        );

        // Puts focus on the newWindow
        if (newWindow.focus) {
          newWindow.focus();
        }

        //Attaching message event listner
        var eventMethod = window.addEventListener
          ? "addEventListener"
          : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent =
          eventMethod == "attachEvent" ? "onmessage" : "message";

        // Listen to message from child window
        eventer(messageEvent, this.handleAuthenticateEvent, false);
      });

    return false;
  }

  handleAuthenticateEvent(e) {
    //Removing message event listner
    var detachEventMethod = window.removeEventListener
      ? "removeEventListener"
      : "detachEvent";
    var deEventer = window[detachEventMethod];
    var messageEvent =
      detachEventMethod == "detachEvent" ? "onmessage" : "message";

    if (e.data.type == "NETSUITE_AUTHORIZATION_SUCCESS") {
      var company = e.data.payload.company;
      var code = e.data.payload.code;
      var state = e.data.payload.state;
      var error = e.data.payload.error;
      var entity = e.data.payload.entity;
      var error = e.data.payload.error;

      var url = new URL(this.props.url);
      var clientId = url.searchParams.get("client_id");
      var clientSecret = url.searchParams.get("client_secret");

      var clientId = clientId;
      var clientSecret = clientSecret;
      
      this.props.trackAdoptionMetricsForPluginConnectedEvent('Netsuite');
      if(error) {
        this.setState({
          errors: error
        })
      }

      if (!error) {
        this.props.authenticateAccount(code, company.toLowerCase().replace("_", "-"), entity, clientId, clientSecret);
      }

      deEventer(messageEvent, this.handleAuthenticateEvent, false);
    }
  }
}

export default NetsuiteView;